import { jsx as _jsx } from "react/jsx-runtime";
import { TextField, styled } from "__barrel_optimize__?names=TextField,styled!=!@mui/material";
import React from "react";
const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
        padding: "15px 19px",
        fontSize: "14px",
        fontWeight: 500
    }
});
const StyledInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const error = Boolean(props.error);
    return /*#__PURE__*/ _jsx(CustomTextField, {
        ref: ref,
        sx: {
            "& legend": {
                display: "none"
            },
            "& fieldset": {
                top: 0
            }
        },
        ...props,
        error: error
    });
});
StyledInput.displayName = "StyledInput";
export default StyledInput;
